import { DecoratedWorkerShift } from "@/redux/actions/shifts.actions";

export const getCompoundPositionId = (
  s: Pick<DecoratedWorkerShift, "positionName" | "positionId">
) => `${s.positionId} - ${s.positionName}`;
